import styled from 'styled-components';
import { CommonCard } from '../commonStyles';

export const CarouselCard = styled(CommonCard)`
  box-shadow: 0 9px 21px 0 rgba(0, 0, 0, 0.08);
  border: solid 1px #f5f5f5;
  margin-bottom: ${(props) => (props.page ? '50px' : `0px`)};
  padding: 0px 20px;
  .ant-row {
    min-height: ${(props) => (props.isFull ? '185px' : '130px')};
  }

  @media only screen and (max-width: 990px) {
    margin-top: ${(props) => (props.isFull ? '20px' : '0')};
    .ant-row {
      min-height: 175px;
    }
    padding: 0px 10px;
  }
  @media only screen and (max-width: 576px) {
    height: 254px;
    .ant-row {
      min-height: 178px;
    }
    padding: 0px 10px;
  }
  @media only screen and (max-width: 320px) {
    height: 296px;
    .ant-row {
      min-height: 178px;
    }
    padding: 0px 10px;
  }
`;

export const CardLeaf = styled.div`
  position: absolute;
  bottom: 0;
  right: -20px;
  @media only screen and (max-width: 1025px) {
    right: -20px;
    bottom: 0px;
  }
  @media only screen and (max-width: 990px) {
    right: -10px;
    bottom: 8px;
  }
`;
export const CarouselContainer = styled.div`
  height: ${(props) => (props.isFull ? '238px' : '172px')}; /* FOR FULL */
  padding: 28px 50px 0px 55px; /* FOR FULL */
  @media only screen and (max-width: 1025px) {
    padding: 28px 45px 0px 45px;
  }
  @media only screen and (max-width: 576px) {
    padding: 26px 35px 0px 35px;
    height: ${(props) => (props.isFull ? '251px' : '261px')};
  }
  @media only screen and (max-width: 320px) {
    padding: 26px 35px 0px 35px;
    height: 302px;
    overflow: auto;
  }
`;

export const CarouselFeatured = styled.div`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.secondary};
  font-weight: ${(props) => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${(props) => props.theme.fontStretch.normal};
  line-height: ${(props) => props.theme.lineHeight.secondary};
  letter-spacing: ${(props) => props.theme.letterSpacing.point9};
  color: ${(props) => props.theme.fontColors.textColor};
  @media only screen and (max-width: 990px) {
    font-size: ${(props) => props.theme.fontSize.secondary};
    line-height: ${(props) => props.theme.lineHeight.secondary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${(props) => props.theme.fontSize.tertiary};
    line-height: ${(props) => props.theme.lineHeight.tertiary};
  }
`;

export const CarouselHeading = styled.div`
  font-family: ${(props) => props.theme.fontFamily.berkeleyStdBold};
  font-size: ${(props) => props.theme.fontSize.h4};
  font-style: normal;
  font-stretch: ${(props) => props.theme.fontStretch.normal};
  line-height: ${(props) => props.theme.lineHeight.h4};
  letter-spacing: ${(props) => props.theme.letterSpacing.point8};
  color: ${(props) => props.theme.fontColors.headingColor};
  margin-top: 6px;
  @media only screen and (max-width: 990px) {
    font-size: ${(props) => props.theme.fontSize.h5};
    line-height: ${(props) => props.theme.lineHeight.h5};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${(props) => props.theme.fontSize.h5};
    line-height: ${(props) => props.theme.lineHeight.h5};
  }
`;

export const CarouselBody = styled.div`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.primary};
  font-weight: ${(props) => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${(props) => props.theme.fontStretch.normal};
  line-height: ${(props) => props.theme.lineHeight.primary};
  letter-spacing: ${(props) => props.theme.letterSpacing.point6};
  color: ${(props) => props.theme.fontColors.textColor};
  padding: 30px 0 20px 0; /* FOR FULL */
  a {
    color: ${(props) => props.theme.colors.primaryColor};
  }
  @media only screen and (max-width: 990px) {
    font-size: ${(props) => props.theme.fontSize.secondary};
    line-height: ${(props) => props.theme.lineHeight.secondary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${(props) => props.theme.fontSize.secondary};
    line-height: ${(props) => props.theme.lineHeight.secondary};
    padding: 5px 0 0 0;
  }
`;
export const LearnMoreDiv = styled.div`
  position: absolute;
  bottom: 0px;
  left: ${(props) => (props.isFull ? '0' : '30.7%')};
  @media only screen and (max-width: 990px) {
    bottom: 0px;
    left: 0%;
  }
  @media only screen and (max-width: 576px) {
    bottom: -16px;
    left: 0%;
  }
`;

export const CarouselDiv = styled.div`
  position: relative;
  .slick-list {
    @media only screen and (max-width: 576px) {
      height: 250px;
    }
  }
`;

export const LeftArrow = styled.div`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
`;

export const RightArrow = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
`;
